<div class="rs-maxh rs-padding-bottom2" data-cy="nortonActivationSection">
  <div
    class="panel rs-bg-grey1 rs-no-margin-bottom rs-maxh rs-flex rs-flex-dir-col rs-overflow-hidden"
  >
    <div class="rs-flex-row">
      <div class="rs-flex-columns">
        <h3 class="rs-tit6">{{ 'norton.activation.title' | translate }}</h3>
      </div>
      <div class="rs-flex-columns" *ngIf="isPending">
        <px-loading-spinner></px-loading-spinner>
        <span class="show-for-sr">{{ 'norton.activation.spinner.accessibility' | translate }}</span>
      </div>
    </div>
    <px-alert [alertKey]="'nortonActivationAlert'"></px-alert>
    <div *ngIf="!isPending && productKey" class="rs-flex-row">
      <div class="rs-flex-columns">
        <p class="rs-padding-bottom1">
          {{ 'norton.activation.productKey' | translate }}
        </p>
      </div>
      <div class="rs-flex-columns">
        <p class="rs-padding-bottom1 rs-word-break-all">
          <strong>{{ productKey }}</strong>
        </p>
      </div>
    </div>
    <div *ngIf="!isPending && nortonAccount" class="rs-flex-row">
      <div class="rs-flex-columns">
        <p class="rs-padding-bottom1">
          {{ 'norton.activation.account' | translate }}
        </p>
      </div>
      <div class="rs-flex-columns">
        <p class="rs-padding-bottom1 rs-word-break-all">
          <strong>{{ nortonAccount }}</strong>
        </p>
      </div>
    </div>
    <div class="rs-me"></div>
    <div class="rs-flex-grow rs-flex rs-flex-bottom">
      <p>
        <a
          href="{{ 'norton.activation.howTo.button.link' | translate }}"
          target="_blank"
          data-tms-event="link-click"
          attr.data-tms-link-zone="{{ 'norton.activation.title' | translate }}"
          attr.data-tms-link-name="{{ 'norton.activation.howTo.button.label' | translate }}"
          attr.data-tms-link-url="{{ 'norton.activation.howTo.button.link' | translate }}"
          >{{ 'norton.activation.howTo.button.label' | translate }}</a
        >
      </p>
    </div>
  </div>
</div>
